module.exports = __webpack_public_path__ + "static/media/15604458141501886752638.3cdd02ed.jpg";